module.exports = __webpack_public_path__ + "static/media/Karta Produktu_BNPP_CASHCPI_3_3. 3.2020_Cardif_Rzeczówka Light.1d594119.pdf";